<script>
export default {
	data() {
		return {
			me: false
		}
	},
	created() {
  	this.emitter.on("updated:user",this.refresh);
  },
  beforeUnmount() {
		this.emitter.off('updated:user',this.refresh);
	},
	mounted() {
		this.refresh();
	},
	methods: {
		refresh() {
  		this.me = this.$store.getters.getUser;
  		this.$forceUpdate();
  	},
  	updateUser(enc_user) {
  		this.$store.commit('updateRawUser', enc_user);
			this.$nextTick(() => {
    		this.emitter.emit("updated:user");
    	});
  	}
	}
}

</script>
